// extracted by mini-css-extract-plugin
export var bounce = "_lr-1";
export var generatingText = "_lr-6";
export var lightning = "_lr-4";
export var popup = "_lr-5";
export var progressBar = "_lr-7";
export var progressFill = "_lr-8";
export var progressShimmer = "_lr-9";
export var progressText = "_lr-a";
export var shimmer = "_lr-3";
export var uploadIcon = "_lr-0";
export var uploadingText = "_lr-2";